var map = {
	"./Presentacion_10_febrero_2023_seminario.pdf": 2949,
	"./RLESem6-1.pdf": 8571,
	"./alberto_maldonado_thesis_advance_fifth_semester.pdf": 1115,
	"./david_perez_dcc_seminario-RYM-15feb2023v2.pdf": 2712,
	"./jesus.pdf": 7087
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2331;